export default __webpack_public_path__ + "static/media/Tortoise Shell.3bf63128.PNG";